export default __webpack_public_path__ + "static/media/checked-green-no-outline.e6343c2d.svg";